export function Building({building_id, building_name}) {
  this.buildingId = building_id;
  this.buildingName = building_name;
}
